import { getDetailedErrorMessage } from "../../utils";
export class PublisherAllowListFetchFailed extends Error {
    /**
     * @param apiError: the error received from the API.
     * @param fallbackMessage: the message to use for the error, if the API error does not contain anything relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PublisherAllowListFetchFailed);
        }
        this.name = "PublisherAllowListFetchFailed";
        this.message = `Failed to fetch publisher allow list. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class PublisherAllowListSaveFailed extends Error {
    /**
     * @param apiError: the error received from the API.
     * @param fallbackMessage: the message to use for the error, if the API error does not contain anything relevant.
     */
    constructor(apiError, fallbackMessage = "Failed to save publisher allow list. Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PublisherAllowListSaveFailed);
        }
        this.name = "PublisherAllowListSaveFailed";
        this.message = `${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
//# sourceMappingURL=errors.js.map